import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["booking", "bol", "container"]

  connect() {
    this.actionType = this.element.dataset.actionType;
    this.initializeFields();
  }

  initializeFields() {
    const selectedUsage = this.element.querySelector('input[name="usage"]:checked');
    if (selectedUsage) {
      switch (selectedUsage.value) {
        case "import":
          this.showImport();
          break;
        case "export":
          this.showExport();
          break;
      }
    }
  }

  showImport() {
    if (this.actionType === "pick_up") {
      this.bolTarget.style.display = "block";
      this.containerTarget.style.display = "block";
      this.bookingTarget.style.display = "none";
      this.clearFields(this.bookingTarget)
    } else if (this.actionType === "drop_off") {
      this.bolTarget.style.display = "block";
      this.bookingTarget.style.display = "none";
      this.clearFields(this.bookingTarget)
    }
  }

  showExport() {
    if (this.actionType === "pick_up") {
      this.bookingTarget.style.display = "block";
      this.containerTarget.style.display = "block";
      this.bolTarget.style.display = "none";
      this.clearFields(this.bolTarget)
    } else if (this.actionType === "drop_off") {
      this.bookingTarget.style.display = "block";
      this.bolTarget.style.display = "none";
      this.clearFields(this.bolTarget)
    }
  }

  clearFields(container) {
    // Clear all inputs within the given container.
    container.querySelectorAll('input, select, textarea').forEach(el => {
      el.value = ''
      el.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
